let squareItems = document.getElementsByClassName('square-content');

/**
 * Function for add/remove class for active open filter category
 */
function triggerAction(thisElement, thisIndex) {
    Array.from(squareItems).forEach((element, index) => {
        if(thisIndex === index) {
            console.log("CLICK ON", index, element)
        } else {
            //console.log("NOT SORT BY", index)
        }
    });
}

/**
 * Add onclick trigger action
 */
Array.from(squareItems).forEach((element, index, elements) => {
    element.onclick = (element) => {
        triggerAction(element, index)
    }
});
